export default __webpack_public_path__ + "static/media/back.b2c4be20.svg";